import React, { PureComponent } from 'react';

class Header extends PureComponent {
  render() {
    return (
      <div className="header">
        <img src="img/logo.svg" width="150" height="109" />
        <div className="header-title">
          <span onClick={ this.props.clicLogo }>{ this.props.labels.title }</span>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js